import React, { useState } from "react";

type DefaultImage = "main" | "secondary";

export enum GridLayout {
  SMALL = "small",
  LIST = "list",
  MEDIUM = "medium",
  LARGE = "large",
}

const LOCALSTORAGE_KEY_FOR_GRID_LAYOUT = "gridLayout";

type ViewSettingsProps = {
  changeDefaultImage: (value: DefaultImage) => void;
  isMainImage: boolean;
  isSecondaryImage: boolean;
  gridLayout: GridLayout;
  setGridLayout: (layout: GridLayout) => void;
};

type ViewSettingsProviderProps = ViewSettingsProps | null;

export const ViewSettingsContext = React.createContext<ViewSettingsProviderProps>(null);

export const ViewSettingsProvider: React.FC = ({ children }) => {
  const [defaultImage, setDefaultImage] = useState("main");
  const isMainImage = defaultImage === "main";
  const isSecondaryImage = defaultImage === "secondary";
  const changeDefaultImage = (value: DefaultImage) => {
    setDefaultImage(value);
  };

  const [gridLayout, setGridLayoutState] = useState<GridLayout>(() => {
    try {
      const storedLayout = localStorage.getItem(LOCALSTORAGE_KEY_FOR_GRID_LAYOUT);
      return storedLayout ? JSON.parse(storedLayout) : GridLayout.MEDIUM;
    } catch (error) {
      console.error("Error parsing localStorage data:", error);
      return GridLayout.MEDIUM;
    }
  });

  const setGridLayout = (layout: GridLayout) => {
    setGridLayoutState(layout);
    localStorage.setItem(LOCALSTORAGE_KEY_FOR_GRID_LAYOUT, JSON.stringify(layout));
  };

  return (
    <ViewSettingsContext.Provider
      value={{
        changeDefaultImage,
        isMainImage,
        isSecondaryImage,
        gridLayout,
        setGridLayout,
      }}
    >
      {children}
    </ViewSettingsContext.Provider>
  );
};
